import {useTranslation} from "react-i18next";
import Accordion from "../../../../../../../../components/blocks/Accordion";
import AccordionItem from "../../../../../../../../components/blocks/Accordion/AccordionItem";
import FormInput from "../../../../../../../../components/blocks/FormInput";
import {useQuery} from "../../../../../../../../hooks/useQuery";
import {BackendServices} from "../../../../../../../../services";
import {SettingKeys} from "../../../../../../../../services/settingService/models/SettingTypes";

export const RefereeReward = () => {
    const {t} = useTranslation("Orders");
    const { data, loading } = useQuery({
        queryFn: async () => {
            return await BackendServices.settingsService.getSettingValue(SettingKeys.RefereeRewards);
        },
    });
    
    return (
        <Accordion>
            <AccordionItem initiallyOpen title={t("rewards")} elementId={"rewards"}>
                <div className="d-flex gap-2 flex-wrap">
                    <FormInput
                        label={t("judgeRewardAmount")}
                        disabled
                        leftElement={<span className="text-primary">{t("ryal")}</span>}
                        value={data?.value}
                    />
                </div>
                <div className="divider mt-4 "></div>
            </AccordionItem>
        </Accordion>
    );
}